import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/countryCode',
  title: window.language['menu.sysConfig.countryCode'],
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});
export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/CountryCode/index.js